import React, { useEffect, forwardRef } from 'react';
import { Placement } from 'popper.js';
import { useResizeObserver } from 'hooks/useResizeObserver';
import { mergeRefs } from 'utils/Refs';

export interface ICalloutContentProps extends React.HTMLProps<HTMLElement> {
  /**
   * Sets placement for callout.
   */
  placement: Placement;
  'data-testid'?: string;
  scheduleUpdate: () => void;
}

export const CalloutContent = forwardRef(
  ({ placement, children, scheduleUpdate, ...otherProps }: ICalloutContentProps, ref: React.Ref<HTMLElement>) => {
    const [dropDownRef, observerEntry] = useResizeObserver();

    useEffect(() => {
      scheduleUpdate();
    }, [observerEntry, scheduleUpdate]);

    return (
      <section aria-label="Dropdown" ref={mergeRefs([ref, dropDownRef])} {...otherProps}>
        {children}
      </section>
    );
  }
);
